import React from 'react';

// Components
import ChangeLogEntry from './ChangeLogEntry';

const ChangeLogEntries = ({ entries }) => (
  <ol>
    { entries.map((entry, index) => <ChangeLogEntry {...entry} key={index} />) }
  </ol>
)

export default ChangeLogEntries



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/ChangeLogEntries.js